// Central test ID registry for Set The Pace OS

export const AUTH = {
  emailInput: 'auth-email-input',
  passwordInput: 'auth-password-input',
  nameInput: 'auth-name-input',
  loginBtn: 'auth-login-btn',
  signupBtn: 'auth-signup-btn',
  logoutBtn: 'auth-logout-btn',
  toggleMode: 'auth-toggle-mode',
};

export const LAYOUT = {
  sidebar: 'app-sidebar',
  navDashboard: 'nav-dashboard',
  navPeople: 'nav-people',
  navCompanies: 'nav-companies',
  navPipeline: 'nav-pipeline',
  navTasks: 'nav-tasks',
  navAi: 'nav-ai',
  globalSearchTrigger: 'global-search-trigger',
  globalSearchInput: 'global-search-input',
  aiAssistantTrigger: 'ai-assistant-trigger',
};

export const DASHBOARD = {
  root: 'dashboard-root',
  totalPeople: 'metric-total-people',
  totalCompanies: 'metric-total-companies',
  openTasks: 'metric-open-tasks',
  weeklyInteractions: 'metric-weekly-interactions',
  warmLeads: 'panel-warm-leads',
  todayFollowups: 'panel-today-followups',
  pipelineSummary: 'panel-pipeline-summary',
  recentActivity: 'panel-recent-activity',
  onboarding: 'panel-coaching-onboarding',
  onboardingRow: (id) => `onboarding-row-${id}`,
  onboardingAction: (id) => `onboarding-action-${id}`,
};

export const PEOPLE = {
  list: 'people-list',
  addBtn: 'people-add-btn',
  row: (id) => `people-row-${id}`,
  detailRoot: 'person-detail-root',
  editBtn: 'person-edit-btn',
  saveBtn: 'person-save-btn',
  deleteBtn: 'person-delete-btn',
  aiSummaryBtn: 'person-ai-summary-btn',
  aiDraftBtn: 'person-ai-draft-btn',
  addNoteBtn: 'person-add-note-btn',
  noteInput: 'person-note-input',
};

export const COMPANIES = {
  list: 'companies-list',
  addBtn: 'companies-add-btn',
  row: (id) => `company-row-${id}`,
  detailRoot: 'company-detail-root',
  saveBtn: 'company-save-btn',
};

export const PIPELINE = {
  board: 'pipeline-board',
  column: (s) => `pipeline-col-${s.toLowerCase().replace(/ /g, '-')}`,
  card: (id) => `pipeline-card-${id}`,
};

export const TASKS = {
  list: 'tasks-list',
  addBtn: 'tasks-add-btn',
  row: (id) => `task-row-${id}`,
  toggle: (id) => `task-toggle-${id}`,
};

export const AI = {
  drawer: 'ai-drawer',
  input: 'ai-input',
  send: 'ai-send',
  message: (i) => `ai-msg-${i}`,
};
